import { DataAccessService } from "./basic.service";

class TabletsDataAccessService extends DataAccessService {

    constructor(collectionName: string) {
        super(collectionName);
    }
}

let collectionPrefix = '';
if (process.env.VUE_APP_MODE == 'dev') {
    collectionPrefix = 'test_';
}
const collectionName =  'tablets';

export default new TabletsDataAccessService([ collectionPrefix, collectionName ].join(''));